export default {
  header: {
    notes: 'Header in list recommendations pane',
    message: 'Parts recommendations',
  },
};
